import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './NotificationItem.m.sass';
var NotificationItem = function NotificationItem(_ref) {
  var notification = _ref.notification,
    onClick = _ref.onClick;
  var _React$useState = React.useState(notification.imageUrl || notification.imageFallbackUrl),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    src = _React$useState2[0],
    setSrc = _React$useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root, notification.status === 'Read' && styles.read),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.imageContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    onError: function onError() {
      return setSrc(notification.imageFallbackUrl);
    },
    className: styles.image
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.text,
    dangerouslySetInnerHTML: {
      __html: notification.messageHtml
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.foot
  }, notification.dateDispatch.fromNow())), /*#__PURE__*/React.createElement("div", {
    className: styles.status
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.statusIndicator, notification.status === 'Read' && styles.read)
  })));
};
export default observer(NotificationItem);
//# sourceMappingURL=index.js.map
